const storedUser = JSON.parse(localStorage.getItem('user'));

const initialState = {
    isAuthenticated: !!storedUser,
    user: storedUser || null,
};

const authReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'LOGIN_SUCCESS':
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload,
            };
        case 'LOGOUT':
            return {
                ...state,
                isAuthenticated: false,
                user: null,
            };
        default:
            return state;
    }
};

export default authReducer;
